/**
 * UI icon name map and IconName type. Extracted from icons.ts for smaller module size.
 */

export type IconName =
  | 'grip-vertical'
  | 'grip-horizontal'
  | 'dots-three-vertical'
  | 'x'
  | 'circle-notch'
  | 'plus'
  | 'plus-square'
  | 'google-chrome-logo'
  | 'sparkles'
  | 'eye'
  | 'eye-off'
  | 'power'
  | 'chevron-up'
  | 'chevron-down'
  | 'chevron-right'
  | 'chevron-left'
  | 'maximize-2'
  | 'minimize-2'
  | 'play'
  | 'pause'
  | 'frame-corners'
  | 'mouse-pointer'
  | 'cursor-text'
  | 'hand'
  | 'lasso'
  | 'menu'
  | 'zoom-in'
  | 'picture-in-picture'
  | 'layout-sidebar-right'
  | 'layout-sidebar-left-collapse'
  | 'layout-grid'
  | 'grid-pattern'
  | 'square-split-horizontal'
  | 'tree-structure'
  | 'hash-straight'
  | 'transition-left'
  | 'square-x'
  | 'preset'
  | 'prohibit'
  | 'folder-open'
  | 'house'
  | 'search'
  | 'arrows-maximize'
  | 'arrows-minimize'
  | 'copy'
  | 'download-simple'
  | 'upload-simple'
  | 'photo'
  | 'image-square'
  | 'video'
  | 'warning'
  | 'brand-youtube'
  | 'help-circle'
  | 'book-open-text'
  | 'keyboard'
  | 'circle-check'
  | 'circle-x'
  | 'music'
  | 'chart-column'
  | 'arrow-move-right'
  | 'matrix'
  | 'equal'
  | 'minus'
  | 'minus-circle'
  | 'trash'
  | 'wave-sine'
  | 'waveform'
  | 'bezier-curve'
  | 'music-note-simple'
  | 'line-segments'
  | 'trend-up'
  | 'trend-down'
  | 'flame'
  | 'lock-access'
  | 'lock-access-off'
  | 'plug'
  | 'multiply'
  | 'curly-loop'
  | 'repeat'
  | 'skip-back'
  | 'skip-forward'
  | 'swap'
  | 'arrows-in-line-vertical'
  | 'dots-nine'
  | 'palette'
  | 'user'
  | 'sign-out'
  | 'graph-undo'
  | 'graph-redo'
  | 'arrow-u-up-left'
  | 'selection-plus'
  | 'selection-all';

/** IconName → Phosphor icon name (kebab-case) */
export const iconNameMap: Record<IconName, string> = {
  'grip-vertical': 'dots-six-vertical',
  'grip-horizontal': 'dots-six',
  'dots-three-vertical': 'dots-three-vertical',
  'x': 'x',
  'circle-notch': 'circle-notch',
  'plus': 'plus',
  'plus-square': 'plus-square',
  'google-chrome-logo': 'google-chrome-logo',
  'sparkles': 'sparkle',
  'eye': 'eye',
  'eye-off': 'eye-slash',
  'power': 'power',
  'chevron-up': 'caret-up',
  'chevron-down': 'caret-down',
  'chevron-right': 'caret-right',
  'chevron-left': 'caret-left',
  'maximize-2': 'arrows-out',
  'minimize-2': 'arrows-in',
  'play': 'play',
  'pause': 'pause',
  'frame-corners': 'frame-corners',
  'mouse-pointer': 'cursor-click',
  'cursor-text': 'cursor-text',
  'hand': 'hand-pointing',
  'lasso': 'selection',
  'menu': 'list',
  'zoom-in': 'magnifying-glass-plus',
  'picture-in-picture': 'picture-in-picture',
  'layout-sidebar-right': 'sidebar-simple',
  'layout-sidebar-left-collapse': 'sidebar-simple',
  'layout-grid': 'grid-four',
  'grid-pattern': 'checkerboard',
  'square-split-horizontal': 'square-split-horizontal',
  'tree-structure': 'tree-structure',
  'hash-straight': 'hash-straight',
  'transition-left': 'arrow-left',
  'square-x': 'x-square',
  'preset': 'bookmark',
  'prohibit': 'prohibit',
  'folder-open': 'folder-open',
  'house': 'house',
  'multiply': 'asterisk',
  'search': 'magnifying-glass',
  'arrows-maximize': 'arrows-out',
  'arrows-minimize': 'arrows-in',
  'copy': 'copy',
  'download-simple': 'download-simple',
  'upload-simple': 'upload-simple',
  'photo': 'image',
  'image-square': 'image-square',
  'video': 'video',
  'warning': 'warning',
  'brand-youtube': 'youtube-logo',
  'help-circle': 'question',
  'book-open-text': 'book-open-text',
  'keyboard': 'keyboard',
  'circle-check': 'check-circle',
  'circle-x': 'x-circle',
  'music': 'music-notes',
  'chart-column': 'chart-bar',
  'arrow-move-right': 'arrow-right',
  'matrix': 'grid-four',
  'equal': 'equals',
  'minus': 'minus',
  'minus-circle': 'minus-circle',
  'trash': 'trash',
  'wave-sine': 'wave-sine',
  'waveform': 'waveform',
  'bezier-curve': 'bezier-curve',
  'music-note-simple': 'music-note-simple',
  'line-segments': 'line-segments',
  'trend-up': 'trend-up',
  'trend-down': 'trend-down',
  'flame': 'flame',
  'lock-access': 'lock',
  'lock-access-off': 'lock-open',
  'plug': 'plug',
  'curly-loop': 'infinity',
  'repeat': 'repeat',
  'skip-back': 'skip-back',
  'skip-forward': 'skip-forward',
  'swap': 'swap',
  'arrows-in-line-vertical': 'arrows-in-line-vertical',
  'dots-nine': 'dots-nine',
  'palette': 'palette',
  'user': 'user',
  'sign-out': 'sign-out',
  'graph-undo': 'arrow-counter-clockwise',
  'graph-redo': 'arrow-clockwise',
  'arrow-u-up-left': 'arrow-u-up-left',
  'selection-plus': 'selection-plus',
  'selection-all': 'selection-all',
};
